export default "__VITE_ASSET__Ud0VMpac__$_?url__"